import clsx from "clsx";

import type { ButtonBase } from "@shared/content-types/schemas/common.schema";
import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Body, Heading } from "@shared/ui/typography";

import s from "./location-map-card-layout.module.scss";

type LocationMapCardLayoutProps = {
  title: string;
  button?: ButtonBase;
  children: React.ReactNode;
  map?: React.ReactNode;
  className?: string;
  description?: string;
  onButtonClick?: () => void;
};

export const LocationMapCardLayout = ({
  title,
  button,
  children,
  map,
  className,
  onButtonClick,
  description,
}: LocationMapCardLayoutProps) => {
  return (
    <div className={clsx(s.root, className)}>
      <div className={s.infoBlock}>
        <div className={s.title}>
          {title && (
            <Heading level={4} tag="h2">
              {title}
            </Heading>
          )}
          {description && <Body size="caption">{description}</Body>}
        </div>

        <div className={s.contentWrapper}>
          <div className={s.content}>{children}</div>

          {button?.link && button?.text && (
            <ButtonWithIcon
              href={onButtonClick ? undefined : button.link}
              onClick={onButtonClick}
              iconName={button.pageIcon?.icon?.name ?? "arrow"}
              iconFillColor={button.pageIcon?.fillColor ?? "cadmium"}
              iconStrokeColor={button.pageIcon?.strokeColor ?? "milk"}
              iconSvgCode={button.pageIcon?.uicon?.svg_code}
              className={s.button}
              variant="primary-dark"
            >
              {button.text}
            </ButtonWithIcon>
          )}
        </div>
      </div>
      {map}
    </div>
  );
};
